const removeHTMLTags  = html => {
  const regX = /(<([^>]+)>)/ig;
  return html.replace(regX, "");
};

export default removeHTMLTags;
